import { useTenant } from '@providers/Tenant';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { SegmentsService } from '../api/segmentsService';

export function useListSegments(instructionId: string, versionId: string, languageCode?: string) {
  const { accountId } = useTenant();
  const service = useMemo(() => new SegmentsService(), []);

  const {
    data,
    hasNextPage: hasMore,
    fetchNextPage: fetchMore,
    ...rest
  } = useInfiniteQuery({
    queryKey: [instructionQueryKeys.listSegments, versionId],
    queryFn: ({ pageParam: nextToken }) =>
      service.list(accountId, instructionId, versionId, { nextToken, lang: languageCode }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    refetchOnMount: true,
  });

  return { data: data?.pages?.flatMap(({ items }) => items), hasMore, fetchMore, ...rest };
}
